(function ($) {

  $('.single-level-list .title-wrapper').unbind().bind('click', function () {
    $('.single-level-list-content-slide').slick('slickGoTo', $(this).attr('data-slide')).promise().done(function() {
      setTimeout(function() {
        $('.single-level-list-content-slide .slick-list').css({'height':'auto'});
      }, 2000);
    });
    $('.single-level-list .title-wrapper').removeClass('active');
    $(this).addClass('active');
  });

  if ($('.single-level-list-content-slide').length) {
    $('.single-level-list-content-slide').slick({
      arrows: false,
      dots: false,
      swipe: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      cssEase: 'linear',
      adaptiveHeight: true,
    });
  }

  $(window).resize(function () {
    $('.single-level-list-content-slide').slick('resize');
  });


})(jQuery);
